import { CommonModule }              from '@angular/common';
import { NgModule }                  from '@angular/core';
import { FormsModule }               from '@angular/forms';
import { NgbTooltipModule }          from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule }            from '@ng-select/ng-select';
import { SelectFilterBaseComponent } from '@shared/list-operations/components/select-filters/select-filter-base/select-filter-base.component';

@NgModule( {
	declarations: [
		SelectFilterBaseComponent
	],
	imports: [
		// Angular
		CommonModule,
		FormsModule,

		// Third Party
		NgbTooltipModule,
		NgSelectModule
	],
	exports: [
		// Angular
		CommonModule,
		FormsModule,

		// Third Party
		NgbTooltipModule,
		NgSelectModule
	]
} )
export class SelectFilterBaseModule {}
